export const TEST_GROUP_LAUNCHES_EMPTY_CONTENT = {
  title: 'No launches run yet',
  description:
    'Once you create a launch, every execution will be recorded here — with pass/fail results, duration, and who triggered it. Your full run history lives on this tab.',
  ctaLabel: 'Create first launch',
  previewPanelTitle: "WHAT YOU'LL SEE AFTER YOUR FIRST RUN",
};

export const LAUNCHES_EMPTY_PREVIEW_FEATURES = [
  {
    id: 'passFail',
    title: 'Pass / fail results',
    description: 'Per test case, per launch',
    iconKey: 'checkCircle',
  },
  {
    id: 'duration',
    title: 'Run duration',
    description: 'How long each execution took',
    iconKey: 'clock',
  },
  {
    id: 'history',
    title: 'Full history',
    description: 'Every launch, searchable and filterable',
    iconKey: 'history',
  },
  {
    id: 'triggeredBy',
    title: 'Triggered by',
    description: 'Who ran it and when',
    iconKey: 'user',
  },
];
